import styled from "styled-components";
import { TableContainer } from "../../../shared/components/CustomTable/Styled";
import { color } from "../../../shared/styles";

// Keep ListView's borders, header/body padding, typography and row striping.
// Only matrix sizing and alignment are specific to the five-trip layout.
export const PlanTableContainer = styled(TableContainer)`
    && .MuiTableCell-root {
        min-width: 0;
        vertical-align: top;
    }
    && .plan-quantity {
        text-align: right;
        white-space: nowrap;
        font-variant-numeric: tabular-nums;
    }
    .plan-matrix {
        min-width: 1512px;
        table-layout: fixed;
    }
    .plan-matrix thead tr:nth-child(2) th {
        top: 27px;
    }
    .plan-vehicle-column {
        width: 112px;
    }
    .plan-quantity-column {
        width: 72px;
    }
    .plan-item-column {
        width: 208px;
    }
    && .plan-vehicle {
        position: sticky;
        left: 0;
        z-index: 1;
        white-space: nowrap;
        background: ${color.emphasis.NEUTRAL_N0};
        box-shadow: 1px 0 0 ${color.secondary.GREY_4};
    }
    && tbody tr:nth-of-type(even) .plan-vehicle {
        background: ${color.emphasis.NEUTRAL_N5};
    }
    && thead .plan-vehicle {
        z-index: 3;
        background: ${color.secondary.LIGHT_GREY};
    }
    && .plan-trip-cell {
        border-left: 1px solid ${color.secondary.GREY_4};
    }
    .plan-unassigned {
        min-width: 640px;
        table-layout: fixed;
    }
`;
export const PlanWrapper = styled.div`
    min-width: 0;
    font-family: "Noto Sans", sans-serif;
    color: ${color.secondary.CHARCOAL};
    .plan-trip-group {
        padding: 6px 0;
        line-height: 18px;
        overflow-wrap: anywhere;
        white-space: pre-wrap;
    }
    .plan-trip-group + .plan-trip-group {
        border-top: 1px solid ${color.secondary.GREY_4};
    }
    .plan-item {
        display: grid;
        grid-template-columns: calc(25.714286% - 12px) minmax(0, 1fr);
        gap: 16px;
        align-items: baseline;
    }
    .plan-unassigned .plan-item {
        grid-template-columns: 56px minmax(0, 1fr);
    }
    .plan-item + .plan-item {
        margin-top: 4px;
    }
    .plan-trip-details {
        margin-top: 6px;
    }
    .plan-address,
    .plan-note {
        margin-top: 2px;
    }
    .plan-item-name {
        font-weight: 600;
    }
    .plan-unit {
        font-weight: 400;
    }
    .plan-unit,
    .plan-note {
        color: ${color.emphasis.NEUTRAL_N70};
    }
    h3 {
        margin: 16px 0 8px;
        font-size: 13px;
        font-weight: 600;
    }
    .plan-totals {
        display: flex;
        flex-wrap: wrap;
        gap: 8px 24px;
        margin-top: 12px;
        font-size: 13px;
        line-height: 28px;
    }
    .plan-other-totals {
        font-size: 13px;
        line-height: 28px;
    }
    .plan-empty {
        margin: 0 0 12px;
        font-size: 13px;
    }
`;
export const PlanToolbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    margin: 0 0 16px;
`;
export const DateField = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 13px;
    .date-control {
        width: 220px;
    }
`;
